import * as React from 'react';
import { Component, useEffect, ReactNode } from 'react';
import Dashboard from './pages/Dashboard';
import { versionChecker } from './utils/versionChecker';
import { ToastProvider, useToast } from './components/shared/ToastNotification';
import ProductsIndex from './pages/ProductsIndex';
import CustomersIndex from './pages/CustomersIndex';
import VendorsIndex from './pages/VendorsIndex';
import CategoriesIndex from './pages/CategoriesIndex';
import OrdersIndex from './pages/OrdersIndex';
import InvoicesIndex from './pages/InvoicesIndex';
import PurchasesIndex from './pages/PurchasesIndex';
import CustomerShow from './pages/CustomerShow';
import VendorShow from './pages/VendorShow';
import ProductShow from './pages/ProductShow';
import PrintLabels from './pages/PrintLabels';
import CategoryShow from './pages/CategoryShow';
import OrderShow from './pages/OrderShow';
import InvoiceShow from './pages/InvoiceShow';
import PurchaseShow from './pages/PurchaseShow';
import CategoryForm from './pages/CategoryForm';
import ProductUnitsIndex from './pages/ProductUnitsIndex';
import RestocksIndex from './pages/RestocksIndex';
import ProductUnitShow from './pages/ProductUnitShow';
import CalendarIndex from './pages/CalendarIndex';
import ProductForm from './pages/ProductForm';
import CustomerForm from './pages/CustomerForm';
import VendorForm from './pages/VendorForm';
import PurchaseForm from './pages/PurchaseForm';
import RestockForm from './pages/RestockForm';
import ProductFieldsIndex from './pages/ProductFieldsIndex';
import QuickOrderEntry from './pages/QuickOrderEntry';
import QuickProductEntry from './pages/QuickProductEntry';
import OrderForm from './pages/OrderForm';
import InvoiceForm from './pages/InvoiceForm';
// Phase 2 components
import FirmsIndex from './pages/FirmsIndex';
import StaffIndex from './pages/StaffIndex';
import StaffForm from './pages/StaffForm';
import ModulesIndex from './pages/ModulesIndex';
import RolesIndex from './pages/RolesIndex';
import RoleForm from './pages/RoleForm';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Onboarding from './pages/Onboarding';
import ForgotPassword from './pages/ForgotPassword';
import Marketplace from './pages/Marketplace';
import LandingPage from './pages/LandingPage';
import FirmForm from './pages/FirmForm';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';

// Accounting components
import AccountingDashboard from './modules/accounting/components/AccountingDashboard';
import AccountGroupsIndex from './modules/accounting/components/AccountGroupsIndex';
import BankAccountsIndex from './modules/accounting/components/BankAccountsIndex';
import VouchersIndex from './modules/accounting/components/VouchersIndex';
import AccountGroupForm from './modules/accounting/components/AccountGroupForm';
import BankAccountForm from './modules/accounting/components/BankAccountForm';
import VoucherForm from './modules/accounting/components/VoucherForm';
import AccountHeadsIndex from './modules/accounting/components/AccountHeadsIndex';
import AccountHeadShow from './modules/accounting/components/AccountHeadShow';
import AccountGroupShow from './modules/accounting/components/AccountGroupShow';
import BankAccountShow from './modules/accounting/components/BankAccountShow';
import VoucherShow from './modules/accounting/components/VoucherShow';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import HelpPOS from './pages/HelpPOS';
import TaxRatesIndex from './pages/TaxRatesIndex';
import StoreProductPage from './pages/StoreProductPage';
import StoreFront from './pages/StoreFront';
import StorePage from './pages/StorePage';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import AccountSettings from './pages/AccountSettings';

// Accounting Reports
import FinancialReports from './modules/accounting/components/reports/FinancialReports';
import LedgerStatement from './modules/accounting/components/reports/LedgerStatement';
import DayBook from './modules/accounting/components/reports/DayBook';
import CashBook from './modules/accounting/components/reports/CashBook';
import BankBook from './modules/accounting/components/reports/BankBook';
import TrialBalance from './modules/accounting/components/reports/TrialBalance';
import BalanceSheet from './modules/accounting/components/reports/BalanceSheet';
import ProfitLoss from './modules/accounting/components/reports/ProfitLoss';
import IncomeExpense from './modules/accounting/components/reports/IncomeExpense';
import PublicProductShow from './pages/PublicProductShow';
import Scanner from './pages/Scanner';
import ReturnOrdersIndex from './pages/ReturnOrdersIndex';
import ReturnOrderForm from './pages/ReturnOrderForm';
import ReturnOrderShow from './pages/ReturnOrderShow';
import CreditNotesIndex from './pages/CreditNotesIndex';
import ProductFieldForm from './pages/ProductFieldForm';
import BulkImport from './pages/BulkImport';
import LocationsIndex from './pages/LocationsIndex';
import LocationForm from './pages/LocationForm';
// Product Sales System - Master Tables
import FinanceCompaniesIndex from './pages/FinanceCompaniesIndex';
import FinanceCompanyForm from './pages/FinanceCompanyForm';
import FinanceCompanyShow from './pages/FinanceCompanyShow';
import InsuranceCompaniesIndex from './pages/InsuranceCompaniesIndex';
import InsuranceCompanyForm from './pages/InsuranceCompanyForm';
import InsuranceCompanyShow from './pages/InsuranceCompanyShow';
import RtoAgentsIndex from './pages/RtoAgentsIndex';
import RtoAgentForm from './pages/RtoAgentForm';
import RtoAgentShow from './pages/RtoAgentShow';
import InvoicePrint from './pages/InvoicePrint';
import ExchangeDealersIndex from './pages/ExchangeDealersIndex';
import ExchangeDealerForm from './pages/ExchangeDealerForm';
import ExchangeDealerShow from './pages/ExchangeDealerShow';
import OrderRtoManagement from './pages/OrderRtoManagement';
import OrderInstallationManagement from './pages/OrderInstallationManagement';
import OrderFinanceManagement from './pages/OrderFinanceManagement';
import OrderInsuranceManagement from './pages/OrderInsuranceManagement';
import OrderExchangeManagement from './pages/OrderExchangeManagement';

// Delivery Management
import DeliveryRoutesIndex from './pages/delivery/DeliveryRoutesIndex';
import DeliverySubscriptionsIndex from './pages/delivery/DeliverySubscriptionsIndex';
import DeliveryAssignmentsIndex from './pages/delivery/DeliveryAssignmentsIndex';
import PartnerChecklist from './pages/delivery/PartnerChecklist';
import DeliveryTodayView from './pages/delivery/DeliveryTodayView';
import SubscriptionBillingPage from './pages/delivery/SubscriptionBillingPage';

// Portal & Staff Portal
import PortalLayout from './components/layout/PortalLayout';
import PortalDashboard from './pages/portal/PortalDashboard';
import CustomerOrders from './pages/portal/CustomerOrders';
import CustomerInvoices from './pages/portal/CustomerInvoices';
import CustomerDeliveries from './pages/portal/CustomerDeliveries';
import StaffMobilePortal from './pages/portal/StaffMobilePortal';

import FirmSwitcher from './components/layout/FirmSwitcher';
import UserDropdown from './components/layout/UserDropdown';
import { DarkModeProvider, DarkModeToggle } from './components/shared/DarkModeToggle';
import MoreMenu from './pages/MoreMenu';
import SidebarWithBurgerMenu from './components/layout/Sidebar';
import BottomNav from './components/layout/BottomNav';

function AppContent() {
    const location = useLocation();
    const { warning } = useToast();

    // Version checker - detect new deployments on user interaction
    useEffect(() => {
        const handleNewVersion = () => {
            warning(
                'A new version is available! Click to refresh and get the latest updates.',
                0, // Don't auto-dismiss
                {
                    label: 'Refresh Now',
                    onClick: () => versionChecker.forceRefresh()
                }
            );
        };

        versionChecker.startChecking(handleNewVersion);

        return () => {
            versionChecker.stopChecking();
        };
    }, [warning]);

    // Check if on public routes
    const isPublicRoute = ['/', '/login', '/signup', '/onboarding', '/forgot-password', '/marketplace'].includes(location.pathname) || location.pathname.startsWith('/store/firm') || location.pathname.startsWith('/p/');
    
    // Auth Check: Reconcile window.CURRENT_USER with localStorage for SPA style login
    const localUser = JSON.parse(localStorage.getItem('user') || 'null');
    const isAuthenticated = !!((window as any).CURRENT_USER || localUser);
    const userRole = (window as any).CURRENT_USER?.role || localStorage.getItem('user_role');

    // Check if user has any firms using the safely injected firms array or checking length if assuming array
    const hasFirms = ((window as any).CURRENT_USER?.firms?.length > 0) || (localUser?.firms?.length > 0) || true; // Defaulting to true for now if role is customer
    const isFirmCreationpath = location.pathname === '/firms/new';


    // Public store routes - render these before auth check
    if (location.pathname.startsWith('/store/firm/') || location.pathname.startsWith('/p/')) {
        return (
            <Routes>
                <Route path="/store/firm/:slug" element={<StoreFront />} />
                <Route path="/store/firm/:slug/product/:id" element={<StoreProductPage />} />
                <Route path="/p/:slug" element={<PublicProductShow />} />
            </Routes>
        );
    }

    // Unauthenticated view
    if (!isAuthenticated) {
        if (location.pathname === '/') {
            return <LandingPage />;
        }
        if (location.pathname === '/login') {
            return <Login />;
        }
        if (location.pathname === '/signup') {
            return <Signup />;
        }
        if (location.pathname === '/onboarding') {
            return <Onboarding />;
        }
        if (location.pathname === '/forgot-password') {
            return <ForgotPassword />;
        }
        if (location.pathname === '/marketplace') {
            return <Marketplace />;
        }
        // Redirect any other path to login
        if (!isPublicRoute) {
            return <Navigate to="/login" replace />;
        }
    }

    // Authenticated but trying to access login/signup
    // Exception: Allow demo users to access signup/login pages (which should ideally trigger logout or just allow viewing)
    // Only show demo mode when is_demo flag is explicitly set (from Demo button), not from email
    const isDemoUser = (window as any).CURRENT_USER?.is_demo === true;

    useEffect(() => {
        const logoutTrigger = () => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('user_role');
            localStorage.removeItem('current_firm_id');
            delete (window as any).CURRENT_USER;
            delete (window as any).CURRENT_FIRM;

            const form = document.getElementById('sign-out-form') as HTMLFormElement | null;
            if (form) {
                form.submit();
                return;
            }

            window.location.href = '/login';
        };

        (window as any).LOGOUT_TRIGGER = logoutTrigger;

        return () => {
            if ((window as any).LOGOUT_TRIGGER === logoutTrigger) {
                delete (window as any).LOGOUT_TRIGGER;
            }
        };
    }, []);

    // Debug: Log demo user status
    if (process.env.NODE_ENV === 'development') {
        console.log('Demo User Check:', {
            is_demo: (window as any).CURRENT_USER?.is_demo,
            email: (window as any).CURRENT_USER?.email,
            isDemoUser
        });
    }

    if (isAuthenticated && ['/login', '/signup'].includes(location.pathname) && !isDemoUser) {
        const target = userRole === 'customer' ? '/portal' : '/';
        return <Navigate to={target} replace />;
    }

    // Root redirect based on role
    if (isAuthenticated && location.pathname === '/' && userRole === 'customer') {
        return <Navigate to="/portal" replace />;
    }

    // Authenticated but NO FIRMS - Force Onboarding
    if (isAuthenticated && !hasFirms && !isFirmCreationpath && userRole !== 'customer') {
        return <Navigate to="/firms/new" replace />;
    }

    // Portal Routes - Separate Layout
    if (location.pathname.startsWith('/portal')) {
        return (
            <PortalLayout role="customer">
                <Routes>
                    <Route path="/" element={<PortalDashboard />} />
                    <Route path="/orders" element={<CustomerOrders />} />
                    <Route path="/orders/:id" element={<OrderShow />} />
                    <Route path="/invoices" element={<CustomerInvoices />} />
                    <Route path="/invoices/:id" element={<InvoiceShow />} />
                    <Route path="/deliveries" element={<CustomerDeliveries />} />
                    <Route path="*" element={<Navigate to="/portal" replace />} />
                </Routes>
            </PortalLayout>
        );
    }

    // Staff Field Portal Routes
    if (location.pathname.startsWith('/staff') && userRole !== 'customer') {
        return (
            <PortalLayout role="staff">
                <Routes>
                    <Route path="/" element={<StaffMobilePortal />} />
                    <Route path="/deliveries" element={<StaffMobilePortal />} />
                    <Route path="*" element={<Navigate to="/staff" replace />} />
                </Routes>
            </PortalLayout>
        );
    }

    // If implementing "Onboarding Mode", we might want to hide Sidebar/Nav
    if (isAuthenticated && !hasFirms && isFirmCreationpath) {
        return <FirmForm />;
    }

    return (
        <>
            <div className="h-screen bg-slate-50 flex flex-col overflow-hidden">
                <form id="sign-out-form" action="/users/sign_out" method="post" style={{ display: 'none' }}>
                    <input type="hidden" name="_method" value="delete" />
                    <input type="hidden" name="authenticity_token" value={(window as any).CSRF_TOKEN} />
                </form>
                {/* Demo Mode Header - Apple Style */}
                {isDemoUser && (
                    <div className="bg-amber-100 border-b border-amber-200 px-4 py-2 text-center relative z-50">
                        <p className="text-xs font-bold text-amber-900 uppercase tracking-widest flex items-center justify-center gap-2">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                            Demo Mode &mdash; Read Only Access
                        </p>
                    </div>
                )}

                <div className="flex-1 flex min-h-0 overflow-hidden">
                    <SidebarWithBurgerMenu />
                    {/* Main Content */}
                    <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                        {/* Top Navbar highlight */}
                        <nav className="bg-white/80 backdrop-blur-md border-b border-slate-200/60 sticky top-0 z-30 transition-all duration-300">
                            <div className="px-4 sm:px-6 lg:px-8">
                                <div className="flex items-center justify-between h-16 sm:h-20">
                                    {/* Left: Mobile Title or Breadcrumbs */}
                                    <div className="flex items-center gap-4">
                                        <h1 className="text-xl font-black text-slate-800 tracking-tight lg:hidden ml-12">Inventory</h1>

                                        {/* Desktop Breadcrumbs / Title Placeholder */}
                                        <div className="hidden lg:flex items-center gap-2 text-sm font-medium text-slate-500">
                                            <span className="px-2 py-1 bg-slate-100 rounded-lg">Dashboard</span>
                                            <span className="text-slate-300">/</span>
                                            <span className="text-slate-800 font-bold">Overview</span>
                                        </div>
                                    </div>

                                    {/* Right: Firm Switcher & User Menu */}
                                    <div className="flex items-center gap-3 sm:gap-6">
                                        <div className="h-8 w-[1px] bg-slate-200 hidden sm:block"></div>
                                        <FirmSwitcher />
                                        <DarkModeToggle />
                                        <div className="h-8 w-[1px] bg-slate-200 hidden sm:block"></div>
                                        <UserDropdown
                                            user={(window as any).CURRENT_USER}
                                            onLogout={() => (window as any).LOGOUT_TRIGGER()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </nav>

                        {/* Page Content */}
                        <main className="flex-1 overflow-y-auto custom-scrollbar">
                            <div className="px-4 py-4 min-h-full flex flex-col">
                                <Routes>
                                    <Route path="/" element={<Dashboard />} />
                                    <Route path="/firms/new" element={<FirmForm />} />
                                    <Route path="/firms/:id/edit" element={<FirmForm />} />
                                    <Route path="/products" element={<ProductsIndex />} />
                                    <Route path="/products/manage" element={<QuickProductEntry />} />
                                    <Route path="/customers" element={<CustomersIndex />} />
                                    <Route path="/vendors" element={<VendorsIndex />} />
                                    <Route path="/categories" element={<CategoriesIndex />} />
                                    <Route path="/orders" element={<OrdersIndex />} />
                                    <Route path="/invoices" element={<InvoicesIndex />} />
                                    <Route path="/purchases" element={<PurchasesIndex />} />
                                    <Route path="/restocks" element={<RestocksIndex />} />
                                    <Route path="/product_units" element={<ProductUnitsIndex />} />
                                    <Route path="/product_units/:id" element={<ProductUnitShow />} />
                                    <Route path="/calendar" element={<CalendarIndex />} />
                                    <Route path="/store" element={<StorePage />} />
                                    <Route path="/store/analytics" element={<AnalyticsDashboard />} />
                                    <Route path="/marketplace" element={<Marketplace />} />
                                    <Route path="/scan" element={<Scanner />} />
                                    <Route path="/import" element={<BulkImport />} />

                                    {/* Show Pages */}
                                    <Route path="/products/:id" element={<ProductShow />} />
                                    <Route path="/products/:id/print_labels" element={<PrintLabels />} />
                                    <Route path="/customers/:id" element={<CustomerShow />} />
                                    <Route path="/vendors/:id" element={<VendorShow />} />
                                    <Route path="/categories/:id" element={<CategoryShow />} />
                                    <Route path="/orders/:id" element={<OrderShow />} />
                                    <Route path="/invoices/:id" element={<InvoiceShow />} />
                                    <Route path="/invoices/:id/print" element={<InvoicePrint />} />
                                    <Route path="/purchases/:id" element={<PurchaseShow />} />

                                    {/* Returns & Credit Notes */}
                                    <Route path="/returns" element={<ReturnOrdersIndex />} />
                                    <Route path="/returns/new" element={<ReturnOrderForm />} />
                                    <Route path="/returns/:id" element={<ReturnOrderShow />} />

                                    <Route path="/locations" element={<LocationsIndex />} />
                                    <Route path="/locations/new" element={<LocationForm />} />
                                    <Route path="/locations/:id/edit" element={<LocationForm />} />

                                    {/* Product Sales System - Master Tables */}
                                    <Route path="/finance_companies" element={<FinanceCompaniesIndex />} />
                                    <Route path="/finance_companies/new" element={<FinanceCompanyForm />} />
                                    <Route path="/finance_companies/:id" element={<FinanceCompanyShow />} />
                                    <Route path="/finance_companies/:id/edit" element={<FinanceCompanyForm />} />
                                    <Route path="/insurance_companies" element={<InsuranceCompaniesIndex />} />
                                    <Route path="/insurance_companies/new" element={<InsuranceCompanyForm />} />
                                    <Route path="/insurance_companies/:id" element={<InsuranceCompanyShow />} />
                                    <Route path="/insurance_companies/:id/edit" element={<InsuranceCompanyForm />} />
                                    <Route path="/rto_agents" element={<RtoAgentsIndex />} />
                                    <Route path="/rto_agents/new" element={<RtoAgentForm />} />
                                    <Route path="/rto_agents/:id" element={<RtoAgentShow />} />
                                    <Route path="/rto_agents/:id/edit" element={<RtoAgentForm />} />
                                    <Route path="/exchange_dealers" element={<ExchangeDealersIndex />} />
                                    <Route path="/exchange_dealers/new" element={<ExchangeDealerForm />} />
                                    <Route path="/exchange_dealers/:id" element={<ExchangeDealerShow />} />
                                    <Route path="/exchange_dealers/:id/edit" element={<ExchangeDealerForm />} />

                                    <Route path="/credit-notes" element={<CreditNotesIndex />} />

                                    {/* Forms */}
                                    <Route path="/categories/new" element={<CategoryForm />} />
                                    <Route path="/categories/:id/edit" element={<CategoryForm />} />
                                    <Route path="/products/new" element={<ProductForm />} />
                                    <Route path="/products/:id/edit" element={<ProductForm />} />
                                    <Route path="/customers/new" element={<CustomerForm />} />
                                    <Route path="/customers/:id/edit" element={<CustomerForm />} />
                                    <Route path="/vendors/new" element={<VendorForm />} />
                                    <Route path="/vendors/:id/edit" element={<VendorForm />} />
                                    <Route path="/purchases/new" element={<PurchaseForm />} />
                                    <Route path="/restocks/new" element={<RestockForm />} />
                                    <Route path="/restocks/:id/edit" element={<RestockForm />} />

                                    {/* Quick Entry Pages (Horizontal Layouts) */}
                                    <Route path="/orders/manage" element={<QuickOrderEntry />} />
                                    <Route path="/orders/new" element={<OrderForm />} />
                                    <Route path="/orders/:id" element={<OrderShow />} />
                                    <Route path="/orders/:id/rto" element={<OrderRtoManagement />} />
                                    <Route path="/orders/:id/installation" element={<OrderInstallationManagement />} />
                                    <Route path="/orders/:id/finance" element={<OrderFinanceManagement />} />
                                    <Route path="/orders/:id/insurance" element={<OrderInsuranceManagement />} />
                                    <Route path="/orders/:id/exchange" element={<OrderExchangeManagement />} />
                                    <Route path="/orders/:id/edit" element={<OrderForm />} />
                                    <Route path="/invoices/new" element={<InvoiceForm />} />
                                    <Route path="/invoices/:id/edit" element={<InvoiceForm />} />

                                    {/* Settings Section */}

                                    {/* Phase 2: Firms & Staff Management */}
                                    <Route path="/firms" element={<FirmsIndex />} />
                                    <Route path="/staff" element={<StaffIndex />} />
                                    <Route path="/staff/new" element={<StaffForm />} />
                                    <Route path="/staff/:id/edit" element={<StaffForm />} />

                                    {/* Settings: Modules & Roles */}
                                    <Route path="/settings/modules" element={<ModulesIndex />} />
                                    <Route path="/settings/roles" element={<RolesIndex />} />
                                    <Route path="/settings/roles/new" element={<RoleForm />} />
                                    <Route path="/settings/roles/:id/edit" element={<RoleForm />} />
                                    <Route path="/settings/product-fields" element={<ProductFieldsIndex />} />
                                    <Route path="/settings/product-fields/new" element={<ProductFieldForm />} />
                                    <Route path="/settings/account" element={<AccountSettings />} />
                                    <Route path="/settings/help/pos" element={<HelpPOS />} />
                                    <Route path="/settings/tax-rates" element={<TaxRatesIndex />} />
                                    <Route path="/more" element={<MoreMenu />} />
                                    <Route path="/settings/*" element={<div className="mt-8 text-center p-12 bg-white rounded-3xl border border-slate-200 shadow-sm mx-auto max-w-lg"><div className="w-16 h-16 bg-slate-50 rounded-2xl flex items-center justify-center mx-auto mb-6 text-slate-400"><svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg></div><h2 className="text-2xl font-bold text-slate-800 mb-2">Configuration Settings</h2><p className="text-slate-500 mb-6">Settings are being moved to the new React interface. Some sections may be temporarily unavailable.</p></div>} />

                                    {/* Accounting Module */}
                                    <Route path="/accounting/account-heads" element={<AccountHeadsIndex />} />
                                    <Route path="/accounting/account-heads/:id" element={<AccountHeadShow />} />
                                    <Route path="/accounting/account-groups/new" element={<AccountGroupForm />} />
                                    <Route path="/profile" element={<Profile />} />
                                    <Route path="/settings" element={<Settings />} />
                                    <Route path="/accounting/account-groups/:id" element={<AccountGroupShow />} />
                                    <Route path="/accounting/bank-accounts/:id" element={<BankAccountShow />} />
                                    <Route path="/accounting/vouchers/:id" element={<VoucherShow />} />
                                    <Route path="/accounting/account-groups/:id/edit" element={<AccountGroupForm />} />
                                    <Route path="/accounting/bank-accounts/new" element={<BankAccountForm />} />
                                    <Route path="/accounting/bank-accounts/:id/edit" element={<BankAccountForm />} />
                                    <Route path="/accounting/vouchers/new" element={<VoucherForm />} />
                                    <Route path="/accounting/vouchers/:id/edit" element={<VoucherForm />} />
                                    <Route path="/accounting" element={<AccountingDashboard />} />
                                    <Route path="/accounting/account-groups" element={<AccountGroupsIndex />} />
                                    <Route path="/accounting/bank-accounts" element={<BankAccountsIndex />} />
                                    <Route path="/accounting/vouchers" element={<VouchersIndex />} />
                                    <Route path="/units" element={<ProductUnitsIndex />} />

                                    {/* Delivery Management */}
                                    <Route path="/delivery/routes" element={<DeliveryRoutesIndex />} />
                                    <Route path="/delivery/subscriptions" element={<DeliverySubscriptionsIndex />} />
                                    <Route path="/delivery/assignments" element={<DeliveryAssignmentsIndex />} />
                                    <Route path="/delivery/checklist/:assignmentId" element={<PartnerChecklist />} />
                                    <Route path="/delivery/today" element={<DeliveryTodayView />} />
                                    <Route path="/delivery/billing" element={<SubscriptionBillingPage />} />

                                    {/* Accounting Ledger & Reports */}
                                    <Route path="/accounting/ledger" element={<LedgerStatement />} />
                                    <Route path="/accounting/reports" element={<FinancialReports />} />
                                    <Route path="/accounting/reports/ledger-statement" element={<LedgerStatement />} />
                                    <Route path="/accounting/reports/day-book" element={<DayBook />} />
                                    <Route path="/accounting/reports/cash-book" element={<CashBook />} />
                                    <Route path="/accounting/reports/bank-book" element={<BankBook />} />
                                    <Route path="/accounting/reports/trial-balance" element={<TrialBalance />} />
                                    <Route path="/accounting/reports/balance-sheet" element={<BalanceSheet />} />
                                    <Route path="/accounting/reports/profit-loss" element={<ProfitLoss />} />
                                    <Route path="/accounting/reports/income-expense" element={<IncomeExpense />} />

                                    {/* Fallback */}
                                    <Route path="/:module/new" element={<div className="mt-16 text-center text-slate-500">Form coming soon</div>} />

                                    <Route path="/:module/:id/edit" element={<div className="mt-16 text-center text-slate-500">Edit form coming soon</div>} />
                                    <Route path="*" element={<div className="mt-16 text-center text-slate-500 p-12">Page not found or still being migrated</div>} />
                                </Routes>
                            </div>
                        </main>
                    </div>
                </div>
                <BottomNav />
            </div>
        </>
    );
}

// Global Error Boundary - Premium UX
class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        console.error('Critical App Error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
                    <div className="max-w-md w-full bg-white rounded-3xl p-8 border border-slate-200 shadow-2xl text-center">
                        <div className="w-20 h-20 bg-rose-50 rounded-2xl flex items-center justify-center mx-auto mb-6 text-rose-500">
                            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                        </div>
                        <h2 className="text-2xl font-black text-slate-800 mb-2">Something went wrong</h2>
                        <p className="text-slate-500 mb-8">The application encountered a runtime error. Please refresh the page or contact support.</p>
                        <button onClick={() => window.location.reload()} className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest hover:bg-indigo-700 transition-all shadow-xl shadow-indigo-200">
                            Refresh Application
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    return (
        <ErrorBoundary>
            <DarkModeProvider>
                <ToastProvider>
                    <BrowserRouter>
                        <AppContent />
                    </BrowserRouter>
                </ToastProvider>
            </DarkModeProvider>
        </ErrorBoundary>
    );
}

export default App;
